import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-08ff13b5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "card__inner" };
const _hoisted_2 = { class: "channels" };
const _hoisted_3 = ["onClick"];
import WhatsappIcon from '@/components/icons/WhatsappIcon.vue';
import { Mail } from 'lucide-vue-next';
import CoreService from "@/services/core.service";
import { Views } from "@/types/ConfigTypes";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContactChannelsCard',
    props: ['channels'],
    setup(__props) {
        const props = __props;
        const mailformClicked = () => {
            CoreService.push(Views.MAILFORM);
        };
        const whatsappClicked = (number) => {
            CoreService.push(Views.WHATSAPP, { number: number });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.channels, (channel) => {
                        return (_openBlock(), _createElementBlock("div", { key: channel }, [
                            (channel.type === 'WHATSAPP')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "channels__option",
                                    onClick: ($event) => (whatsappClicked(channel.options.number))
                                }, [
                                    _createVNode(WhatsappIcon)
                                ], 8, _hoisted_3))
                                : (channel.type === 'EMAIL')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "channels__option",
                                        onClick: mailformClicked
                                    }, [
                                        _createVNode(_unref(Mail), { size: "24" })
                                    ]))
                                    : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ])
            ]));
        };
    }
});
